import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    flexFlow: 'column wrap !important',
    height: '24rem',

    '&.tier3': {
      height: '30rem',
    },
  },
  city: {
    color: '#585858 !important',
  },
  indexLabel: {
    backgroundColor: `${theme.seafoamGreen} !important`,
    color: '#fff !important',
  },
  cityLabel: {
    fontWeight: 500,
    fontSize: '.900em !important',
    whiteSpace: 'nowrap',

    '&.tier3': {
      fontWeight: 100,
    },
  },
  countLabel: {
    marginTop: '0 !important',
    fontSize: '.750em !important',
    color: `${theme.darkGray} !important`,
  },
  noPadding: {
    padding: '0 !important',
  },
  fullLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  addressLabel: {
    margin: '0 !important',
    color: '#585858 !important',
    fontSize: '.900rem !important',
  },
});

export default styles;
